/* global window, navigator */
// This module is for *reporting* logs to a remote endpoint

const INFO = 'info';
const ERROR = 'error';

class Logger {
	constructor({reporter}) {
		// Reporter should be a function that takes in an object (JSON-style data) and uses XHR or whatever to POST to an endpoint
		this.reporter = reporter;
		this.handleErrorEvent = this.handleErrorEvent.bind(this);
	}

	info(data={}, opts={}) {
		return this.log(INFO, data, opts);
	}

	error(data={}, opts={}) {
		return this.log(ERROR, data, opts);
	}

	// Minimum is a `message` key for data object
	log(level=ERROR, data={}, opts={}) {
		if (!data.message) {
			return;
		}

		if (!data.level) {
			data.level = level;
		}

		const type = opts.type || 'client_js_error';

		data.browser = {
			time: new Date().toISOString(),
			userAgent: navigator.userAgent,
			language: navigator.languages || navigator.language,
			platform: navigator.platform,
		};

		const reporter = opts.reporter || this.reporter;

		if (reporter) {
			reporter({
				[type]: data,
			});
		}
	}

	sanitizeStack(stack='') {
		return stack.replace(/\n+/g, '; ').replace(/\s+/g, ' ');
	}

	handleErrorEvent(e) {
		const {
			meta,
			message,
			filename,
			lineno,
			colno,
			time,
		} = e;

		if (message === 'Script error.') {
			// This is a "generic error" for blocked scripts and we don't want to make a request for it
			// Cross-origin, extensions/addons, and other such scripts will cause problems and give no information
			return;
		}

		const data = {};

		if (message) {
			data.message = message;
		}
		if (window && window.location) {
			data.href = window.location.href;
		}
		if (filename) {
			data.filename = filename;
		}
		if (lineno) {
			data.lineno = lineno;
		}
		if (colno) {
			data.colno = colno;
		}
		if (e && e.stack) {
			data.stack = this.sanitizeStack(e.stack);
		}
		if (time) {
			data.time = time;
		}
		if (meta) {
			data.meta = meta;
		}

		this.error(data);
	}
}

Logger.INFO = INFO;
Logger.ERROR = ERROR;

module.exports = Logger;
